import { render, staticRenderFns } from "./ProjectsStatus.vue?vue&type=template&id=3ac264c9&"
import script from "./ProjectsStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac264c9')) {
      api.createRecord('3ac264c9', component.options)
    } else {
      api.reload('3ac264c9', component.options)
    }
    module.hot.accept("./ProjectsStatus.vue?vue&type=template&id=3ac264c9&", function () {
      api.rerender('3ac264c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/ProjectsStatus.vue"
export default component.exports